module.exports = __webpack_public_path__ + "static/img/broken-seat.29aaaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/broken-seat.jpg
// module id = 982
// module chunks = 37